import { ui } from "@/strings";
import type { RiskLevel } from "@markeroo/shared";

// Re-export shared constants from @markeroo/shared
// Source of truth for thresholds - also mirrored in Python backend
export {
  EDIT_METRICS_THRESHOLDS,
  type EditMetricsThresholds,
} from "@markeroo/shared/constants";

// Re-export RiskLevel from schemas
export type { RiskLevel } from "@markeroo/shared";

/**
 * Risk level styling configuration.
 * Used by both EditMetricsIndicator and EditMetricsModal for consistent appearance.
 */
export const RISK_LEVEL_CONFIG: Record<
  RiskLevel,
  {
    /** Colors for indicator button (includes hover state) */
    indicatorColors: string;
    /** Background color for badge */
    badgeBg: string;
    /** Text color for badge */
    badgeText: string;
  }
> = {
  high: {
    indicatorColors: "text-semantic-error bg-semantic-error-bg hover:bg-semantic-error-bg",
    badgeBg: "bg-semantic-error-bg",
    badgeText: "text-semantic-error",
  },
  medium: {
    indicatorColors: "text-semantic-warning bg-semantic-warning-bg hover:bg-semantic-warning-bg",
    badgeBg: "bg-semantic-warning-bg",
    badgeText: "text-semantic-warning-text",
  },
  low: {
    indicatorColors: "text-semantic-success bg-semantic-success-bg hover:bg-semantic-success-bg",
    badgeBg: "bg-semantic-success-bg",
    badgeText: "text-semantic-success-text",
  },
  none: {
    indicatorColors: "text-theme-muted bg-surface-secondary hover:bg-surface-tertiary",
    badgeBg: "bg-surface-secondary",
    badgeText: "text-theme-secondary",
  },
};

/**
 * Risk level labels for display.
 * Used by both EditMetricsIndicator and EditMetricsModal.
 */
export const RISK_LABELS: Record<RiskLevel, string> = {
  high: ui.editMetrics.riskHigh,
  medium: ui.editMetrics.riskMedium,
  low: ui.editMetrics.riskLow,
  none: ui.editMetrics.noMetrics,
};
